// extracted by mini-css-extract-plugin
export default {"RedirectAskModal":"RedirectAskModal_RedirectAskModal__U8KQd","modalCard":"RedirectAskModal_modalCard__poQug","modalTitle":"RedirectAskModal_modalTitle__8iIO7"};